import React from 'react'
import {Outlet,NavLink,Link} from 'react-router-dom'



const Media=()=> {
  return (
    <><div className="Navigator">
       <div className="Navigator__from"><Link to='/'>Home</Link></div>
       <div className="Navigator__line"></div>
       <div className="Navigator__to">Media</div>
     </div>
    <div className='Media1'>
      
    <div className="navbar1">
        <ul>
          <li><NavLink to="video">Video yangiliklar</NavLink></li>
          <li><NavLink to="photo">Foto yangiliklar</NavLink></li>
          
        </ul>
      </div>
        
    <Outlet/>

    </div></>
  )
}
export default Media 
